module.exports = __webpack_public_path__ + "assets/img/news1.3.9ad6558d.png";